import React, { createContext, useContext, ReactNode } from 'react';
import Toast, {
  displayToast,
  displayPromiseToast,
  displayErrorToast,
  dismissToast,
  displayInfoToast,
} from '@web-packages/atoms/Toast';
import {
  ToastOptions,
  ToastPromiseParams,
} from '@web-packages/atoms/Toast/types';

export type ToastFunctionsType = {
  displayToast: (message: string, options?: ToastOptions) => void;
  displayErrorToast: (message: string, options?: ToastOptions) => void;
  displayInfoToast: (message: string, options?: ToastOptions) => void;
  displayPromiseToast: (promiseFunc: () => Promise<any>, options: ToastPromiseParams) => void;
  dismissToast: (_toastId: string) => void;
};

const ToastContext = createContext<ToastFunctionsType | undefined>(undefined);
const toastFunctions: ToastFunctionsType = {
  displayToast,
  displayErrorToast,
  displayInfoToast,
  displayPromiseToast,
  dismissToast,
};

const ToastProvider = ({ children }: { children: ReactNode }) => (
  <ToastContext.Provider value={toastFunctions}>
    {children}
    <Toast />
  </ToastContext.Provider>
);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export default ToastProvider;
